import Numeral from "numeral";

export const toNicePerc = (num) =>
  num ? Numeral(num).divide(100).format("%0.00a") : "NA";
